import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AllowanceRow, AllowanceStatusRow, AppealSavingsRow, AppealStatusRow, FilterCondition, LiabilityRow, PropertySearchRow, QueryRequest, QueryResponse } from "../../../models/ratings.type";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class RatingsService {
  private base = environment.ratingsApiConfig.baseUrl;
  constructor(private http: HttpClient) {
  }

  liabilityQuery(req: QueryRequest): Observable<QueryResponse<LiabilityRow>> {
    return this.http.post<QueryResponse<LiabilityRow>>(
      `${this.base}/liability/query`, req);
  }

  propertySearchQuery(req: QueryRequest): Observable<QueryResponse<PropertySearchRow>> {
    return this.http.post<QueryResponse<PropertySearchRow>>(
      `${this.base}/property-search/query`, req);
  }

  appealStatusQuery(req: QueryRequest): Observable<QueryResponse<AppealStatusRow>> {
    return this.http.post<QueryResponse<AppealStatusRow>>(
      `${this.base}/appeal-status/query`, req);
  }

  appealSavingsQuery(req: QueryRequest): Observable<QueryResponse<AppealSavingsRow>> {
    return this.http.post<QueryResponse<AppealSavingsRow>>(
      `${this.base}/appeal-savings/query`, req);
  }

  allowanceStatusQuery(req: QueryRequest): Observable<QueryResponse<AllowanceStatusRow>> {
    return this.http.post<QueryResponse<AllowanceStatusRow>>(
      `${this.base}/allowance-status/query`, req);
  }

  allowanceQuery(req: QueryRequest): Observable<QueryResponse<AllowanceRow>> {
    return this.http.post<QueryResponse<AllowanceRow>>(
      `${this.base}/allowance/query`, req);
  }
}

// export function transformFilterModelForApi(
//   agFilterModel: any
// ): Record<string, FilterCondition> {
//   if (!agFilterModel) return {};

//   const out: Record<string, FilterCondition> = {};
//   for (const [col, val] of Object.entries<any>(agFilterModel)) {
//     // Text/Number/Date simple format already matches: { type, filter, filterTo }
//     // But AG Grid sometimes uses `conditions` array with `operator`.
//     if (Array.isArray(val?.conditions) && val.conditions.length === 2 && val.operator) {
//       out[col] = {
//         operator: (val.operator as string)?.toUpperCase() as any,
//         condition1: {
//           type: val.conditions[0]?.type,
//           filter: val.conditions[0]?.filter,
//           filterTo: val.conditions[0]?.filterTo
//         },
//         condition2: {
//           type: val.conditions[1]?.type,
//           filter: val.conditions[1]?.filter,
//           filterTo: val.conditions[1]?.filterTo
//         }
//       };
//     } else {
//       out[col] = {
//         type: val.type,
//         filter: val.filter,
//         filterTo: val.filterTo
//       };
//     }
//   }
//   return out;
// }